import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Switch,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { API_GET_OPEN, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";

const StatisticsManagementTab = () => {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      event: 0,
      caterer: 0,
      food: 0,
      status: 1,
    },
    validationSchema: yup.object({
      event: yup
        .number()
        .required("Event count is required")
        .positive("Event count must be a positive integer")
        .integer("Event count must be an integer"),
      caterer: yup
        .number()
        .required("Caterer count is required")
        .positive("Caterer count must be a positive integer")
        .integer("Caterer count must be an integer"),
      food: yup
        .number()
        .required("Food count is required")
        .positive("count Food  must be a positive integer")
        .integer("Food count must be an integer"),
      status: yup.number().required(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);
        const res = await API_POST(
          API_endspoints.updateSatisticsContent,
          values
        );
        if (res.s) {
          toast.success("Updated Successfully");
        }
        setLoading(false);
        handleData();
      } catch (error) {
        setLoading(false);
        console.log(error);
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const handlePositiveNumberChange = (e) => {
    const { name, value } = e.target;
    if (parseInt(value, 10) >= 0 || value === "") {
      formik.setFieldValue(name, value);
    }
  };

  const handleData = async () => {
    try {
      setLoading(true);
      let res = await API_GET_OPEN(API_endspoints.getSatisticsContent);
      if (res?.s) {
        formik.setValues(res.r);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    handleData();
  }, []);

  return (
    <>
      {loading ? (
        <Box className="flexCenter" sx={{ height: "calc(100vh - 200px)" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: "1440px",
            border: "1px solid #fff",
            borderRadius: "15px",
            boxShadow: "1px 1px 5px grey",
            p: 3,
            py: 4,
            height: "calc(100vh - 220px)",
            overflow: "auto",
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: { md: "2rem" },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box sx={{ width: "100%" }}>
                <label htmlFor="mobile_number">Events Completed</label>
                <TextField
                  type="number"
                  id="event"
                  name="event"
                  onChange={handlePositiveNumberChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.event}
                  error={formik.touched.event && Boolean(formik.errors.event)}
                  helperText={formik.touched.event && formik.errors.event}
                  variant="outlined"
                  fullWidth
                  focused
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },
                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Event"
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <label htmlFor="email">Caterer Count</label>
                <TextField
                  type="number"
                  id="caterer"
                  name="caterer"
                  onChange={handlePositiveNumberChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.caterer}
                  error={
                    formik.touched.caterer && Boolean(formik.errors.caterer)
                  }
                  helperText={formik.touched.caterer && formik.errors.caterer}
                  variant="outlined"
                  fullWidth
                  focused
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },
                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Caterer"
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <label htmlFor="insta">Food Count</label>
                <TextField
                  type="number"
                  id="food"
                  name="food"
                  onChange={handlePositiveNumberChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.food}
                  error={formik.touched.food && Boolean(formik.errors.food)}
                  helperText={formik.touched.food && formik.errors.food}
                  variant="outlined"
                  fullWidth
                  focused
                  sx={{
                    margin: "0.5rem 0 1rem 0",
                    ".MuiInputBase-root": {
                      borderRadius: "11px",
                      background: "#fff",
                      color: "#000",
                    },
                    ".MuiInputBase-root:hover": {
                      background: "#F57C00",
                      color: "#fff",
                    },
                    ".MuiOutlinedInput-input:focus": {
                      outline: "none",
                    },
                    fieldset: {
                      border: "none",
                    },
                  }}
                  placeholder="Enter social link"
                />
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: "1rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  height: "100%",
                }}
              >
                <Typography>Show Content in Web</Typography>
                <Switch
                  checked={formik.values.status === 1}
                  onChange={(e) =>
                    formik.setFieldValue("status", e.target.checked ? 1 : 0)
                  }
                  color="primary"
                />
              </Box>
              <Button
                variant="outlined"
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  backgroundColor: "#164FA1",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#164FA1",
                    color: "white",
                  },
                }}
                type="submit"
                onClick={formik.handleSubmit}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      )}
    </>
  );
};

export default StatisticsManagementTab;
